<template>
    <div class="position-box">
        <div class="head">
            <img class="back" v-if="theme" src="@/assets/theme/icon_back.png" @click="back" alt="">
            <img class="back" v-else src="@/assets/icon_back.png" @click="back" alt="">
            <div class="title">{{$t('chongzhi.cbjl')}}</div>
        </div>
        <div class="cotainer">
            <ul class="item-box" @scroll="listenScroll">
                <li class="item" v-for="(item,index) in list" :key="index">
                    <img class="img" src="@/assets/user/chongbi2.png" alt="">
                    <div class="item-right">
                        <div class="item-head">
                            <div class="item-lt">
                                <div class="t1">{{ item.currency }}</div>
                                <div class="time">{{ item.add_time }}</div>
                            </div>
                            <div class="item-rt">
                                <div class="t2">{{ item.money }}</div>
                                <div class="status" :class="{under: item.status == 0}">{{item.status | status}}</div>
                            </div>
                        </div>
                        <div class="remark"  v-show="item.status == -1">{{ item.remark_re }}</div>
                    </div>
                </li>
                <!-- 暂无数据 -->
                <div class="null-box" v-show="isNoData">
                    <img class="icon" v-if="!theme" src="@/assets/Null.png" alt="">
                    <img class="icon" v-else src="@/assets/theme/wushuju.png" alt="">
                    <p class="text">{{$t('zwsj.title')}}</p>
                </div>
            </ul>
            <!-- 返回顶部 -->
            <img id="goTop" v-if="theme" class="go-top" @click="goTop" v-show="isGoTOP" src="@/assets/theme/goTop_white.png" alt="">
            <img id="goTop" v-else class="go-top" @click="goTop" v-show="isGoTOP" src="@/assets/goTop.png" alt="">
        </div>
    </div>
</template>

<script>
let that = this;
export default {
    name: 'records',
    data () {
        return {
            tabIdx: 0,
            isNoData: false,
            list: [],
            statusText: [],
            isGoTOP: false,
            curDataLength: 10,
            theme: false,
            page: 1
        }
    },
    beforeCreate(){
        that = this;
    },
    created(){
        this.tabIdx = this.$route.query.idx || 0;
        this.statusText = this.$t('status.statusText');
        this.theme = JSON.parse(localStorage.getItem('theme'))
    },
    mounted() {
        this.getMyLog()
    },
    methods: {
       back(){
           this.$router.push('/deposit')
       },
       getMyLog(){
            let url = this.tabIdx ? '/web/takeLog' : '/web/rechargeLog';
            let params = {
                page: this.page
            }
            this.$ajax.get(url,{params}).then((res) => {
                let resData = res.data.data.data;
                if(resData.length > 0){
                    this.list = this.list.concat(resData);
                    this.curDataLength = resData.length;
                }else{
                    this.curDataLength = resData.length;
                }
                if(this.list.length > 0){
                    this.isNoData = false;
                }else{
                    this.isNoData = true;
                }
            }).catch(function(err){
                console.log(err)
            })
       },
       listenScroll(e) {  //监听滚动
            let ele = e.srcElement ? e.srcElement : e.target;
            if(ele.scrollTop > 200){
                this.isGoTOP = true
            }else{
                this.isGoTOP = false
            }
            if (ele.scrollTop + ele.offsetHeight >= ele.scrollHeight) { //监听滚动到div底部
                if(this.curDataLength > 0){
                    this.page ++;
                    this.getMyLog();
                }
            }
        },
       tab(idx){
           this.tabIdx = idx;
           this.list = [];
           this.getMyLog();
       },
       goTop(){
           $('.item-box').animate({scrollTop:'0px'},'slow');
       }
    },
    filters: {
        status: function(val){
            if(val == -1){
                return that.statusText[0]
            }else if(val == 0){
                return that.statusText[1]
            }else if(val == 1){
                return that.statusText[2]
            }else{
                return that.statusText[0]
            }
        }
    },
}
</script>
<style scoped>
    .head{
        position: fixed;
        top: 0;
        width: 100%;
        height: 1.6rem;
        padding: 0 .44rem;
        color: #000;
        line-height: 1.6rem;
        background: #fff;
        box-sizing: border-box;
        text-align: center;
    }
    .head .back{
        position: absolute;
        left: .4rem;
        top: 50%;
        width: .5rem;
        margin-top: -.4rem;
    }
    .head .title{
        font-size: .56rem;
    }
    .cotainer{
        position: absolute;
        top: 1.6rem;
        bottom: 0;
        width: 100%;
        background: #f9f9f9;
        overflow-y: scroll;
    }
    .cotainer .tab-box{
        display: flex;
        align-items: center;
    }
    .cotainer .tab-box .tab{
        width: 50%;
        height: 1.78rem;
        color: #000;
        font-size: .48rem;
        line-height: 1.78rem;
        background: #fff;
        text-align: center;
    }
    .cotainer .tab-box .tab.active{
        color: #588bf8;
    }
    .cotainer .item-box{
        position: absolute;
        top: .3rem;
        bottom: 0;
        width: 100%;
        background: #fff;
        overflow-y: scroll;
    }
    .cotainer .item-box .item{
        display: flex;
        align-items: stretch;
        padding: .6rem .3rem 0 .3rem;
    }
    .cotainer .item-box .item .img{
        width: .68rem;
        height: .68rem;
        margin-right: .3rem;
    }
    .cotainer .item-box .item .item-right{
        flex: 1;
        padding-bottom: .4rem;
        border-bottom: 1px solid #ececec;
    }
    .cotainer .item-box .item .item-head{
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .cotainer .item-box .item .t1{
        color: #000;
        font-size: .48rem;
    }
    .cotainer .item-box .item .t2{
        color: #000;
        font-size: .56rem;
        text-align: right;
    }
    .cotainer .item-box .item .time{
        padding-top: .36rem;
        color: #797979;
        font-size: .34rem;
    }
    .cotainer .item-box .item .status{
        padding-top: .36rem;
        color: #575757;
        font-size: .34rem;
        text-align: right;
    }
    .cotainer .item-box .item .under{
        color: #588bf8;
    }
    .cotainer .item-box .item:last-child .item-right{
        border-bottom: none;
    }
    .cotainer .item-box .item .remark{
        color: #000;
        font-size: .36rem;
        padding: .24rem 0 0;
    }
</style>



// WEBPACK FOOTER //
// src/pages/records.vue